const storesDataMock = [
  {
    storeName: "ABBEVILLE -AMIENS",
    storeId: "3021081173862",
    storeAnabelKey: "1765",
    storeType: "market",
    affiliation: "FRANCHISE",
    leaseManagementTypeName: "Franchisé"
  },
  {
    storeName: "ABBEVILLE -CORDELIER",
    storeId: "3021080655604",
    storeAnabelKey: "7826",
    storeType: "market",
    affiliation: "INTEGRE",
    leaseManagementTypeName: "Franchisé"
  },
  {
    storeName: "AIGUEPERSE -CLERMONT",
    storeId: "3021081153857",
    storeAnabelKey: "7654",
    storeType: "market",
    affiliation: "FRANCHISE",
    leaseManagementTypeName: "Franchisé"
  },
  {
    storeName: "AIRAINES",
    storeId: "3021080322506",
    storeAnabelKey: "7639",
    storeType: "market",
    affiliation: "INTEGRE",
    leaseManagementTypeName: "Franchisé"
  },
  {
    storeName: "AIRE S/L'ADOUR",
    storeId: "3021080565408",
    storeAnabelKey: "8581",
    storeType: "market",
    affiliation: "FRANCHISE",
    leaseManagementTypeName: "Franchisé"
  },
  {
    storeName: "AIRE S/LA LYS",
    storeId: "3021080314300",
    storeAnabelKey: "7301",
    storeType: "hypermarket",
    affiliation: "INTEGRE",
  },
  {
    storeName: "AIX -LES DEUX ORMES",
    storeId: "3021081170625",
    storeAnabelKey: "1698",
    storeType: "market",
    affiliation: "FRANCHISE",
    leaseManagementTypeName: "Franchisé"
  },
  {
    storeName: "AIX EN PRO -LAPIERRE",
    storeId: "3021081175385",
    storeAnabelKey: "1956",
    storeType: "market",
    affiliation: "FRANCHISE",
    leaseManagementTypeName: "Franchisé"
  },
  {
    storeName: "AIX EN PROVENCE",
    storeId: "3020339800700",
    storeAnabelKey: "0501",
    storeType: "hypermarket",
    affiliation: "INTEGRE",
    leaseManagementTypeName: "Franchisé"
  },
  {
    storeName: "AIX LES B -VERLAINE",
    storeId: "3021081061404",
    storeAnabelKey: "7738",
    storeType: "market",
    affiliation: "FRANCHISE",
    leaseManagementTypeName: "Franchisé"
  },
  {
    storeName: "AIX NOULETTE",
    storeId: "3021080813806",
    storeAnabelKey: "7936",
    storeType: "market",
    affiliation: "FRANCHISE",
    leaseManagementTypeName: "Franchisé"
  },
];

const sectorHyperDataMock = [
  {
    hypDepartmentKey: "06",
    hypDepartmentDesc: "PGC",
    ca: 2.312890000000001,
    eb: -0.5467234889999992,
    rh: -18.6947657046437,
    lastCa: 2.8447,
  },
  {
    hypDepartmentKey: "08",
    hypDepartmentDesc: "PFT",
    ca: 0.2605,
    eb: -0.11073822100000003,
    rh: -61.78895179980638,
    lastCa: 0.68174,
  },
  {
    hypDepartmentKey: "09",
    hypDepartmentDesc: "BAZAR",
    ca: 0.23992000000000002,
    eb: 0.07810903400000002,
    rh: 38.131153203984105,
    lastCa: 0.17369,
  },
  {
    hypDepartmentKey: "10",
    hypDepartmentDesc: "EPCS",
    ca: 0.0045,
    eb: -0.004161797000000001,
    rh: -47.058823529411775,
    lastCa: 0.0085,
  },
  {
    hypDepartmentKey: "11",
    hypDepartmentDesc: "TEXTILE",
    ca: 0.7937000000000001,
    eb: 0.05646491500000006,
    rh: 5.7181293871625405,
    lastCa: 0.7507699999999999,
  },
];
const sectorMarketDataMock = [
  {
    hypDepartmentKey: "08",
    hypDepartmentDesc: "PGC",
    ca: 0.2605,
    eb: -0.11073822100000003,
    rh: -61.78895179980638,
    lastCa: 0.68174,
  },
  {
    hypDepartmentKey: "09",
    hypDepartmentDesc: "PFT",
    ca: 0.23992000000000002,
    eb: 0.07810903400000002,
    rh: 38.131153203984105,
    lastCa: 0.17369,
  },
  {
    hypDepartmentKey: "10",
    hypDepartmentDesc: "Non AL",
    ca: 0.0045,
    eb: -0.004161797000000001,
    rh: -47.058823529411775,
    lastCa: 0.0085,
  },
];

const ComparativeMarketDataMock = [
  {
    STR_KEY: "SDV",
    storeGlnKey: "3021081173862",
    turnover: 57104.469999999994,
    Affiliationturnover: 158728051.62999997,
    LastYearAffiliationturnover: 159570985.88999996,
    LastYearRegionturnover: 3021933.14,
    LastYearturnover: 60768.78,
    Regionturnover: 3026162.14,
  },
  {
    STR_KEY: "PGC",
    storeGlnKey: "3021081173862",
    turnover: "48761.88",
    LastYearturnover: "47618.29",
    Regionturnover: "2250197.22",
    LastYearRegionturnover: "2202343.47",
    Affiliationturnover: "115607800.270000001",
    LastYearAffiliationturnover: "114627018.179999997",
  },
  {
    STR_KEY: "PFT",
    storeGlnKey: "3021081173862",
    turnover: "5399.95",
    LastYearturnover: "10370.8",
    Regionturnover: "561373.08",
    LastYearRegionturnover: "553690.11",
    Affiliationturnover: "31693880.65999999",
    LastYearAffiliationturnover: "31294858.089999983",
  },
  {
    STR_KEY: "NON AL",
    storeGlnKey: "3021081173862",
    turnover: "2942.64",
    LastYearturnover: "2779.69",
    Regionturnover: "214591.84",
    LastYearRegionturnover: "265899.56",
    Affiliationturnover: "11426370.699999984",
    LastYearAffiliationturnover: "13649109.619999988",
  },
];
const ComparativeHyperDataMock = [
  {
    STR_KEY: "SDV",
    storeGlnKey: "3020339800700",
    StoreRank: 3,
    turnover: 4245979.059999992,
    LastYearturnover: 4388975.189999996,
    Regionturnover: 32993105.499999974,
    LastYearRegionturnover: 33313792.699999996,
  },
  {
    STR_KEY: "PGC",
    storeGlnKey: 3020339800700,
    StoreRank: 3,
    turnover: 2396879.120000004,
    LastYearturnover: 2451577.98,
    Regionturnover: 19143651.41,
    LastYearRegionturnover: 19215977.410000004,
  },
  {
    STR_KEY: "PFT",
    storeGlnKey: "3020339800700",
    StoreRank: 3,
    turnover: 885303.46,
    LastYearturnover: 884494.140000001,
    Regionturnover: 6407081.32,
    LastYearRegionturnover: 6225483.15,
  },
  {
    STR_KEY: "BAZAR",
    storeGlnKey: 3020339800700,
    StoreRank: 5,
    turnover: 534699.95,
    LastYearturnover: 652997.06,
    Regionturnover: 4156041.809999999,
    LastYearRegionturnover: 4673597.78,
  },
  {
    STR_KEY: "EPCS",
    storeGlnKey: "3020339800700",
    StoreRank: 15,
    turnover: 219218.9,
    LastYearturnover: 194536,
    Regionturnover: 1857922.430000003,
    LastYearRegionturnover: 1750021.510000003,
  },
  {
    STR_KEY: "TEXTILE",
    storeGlnKey: 3020339800700,
    StoreRank: 5,
    turnover: 209877.63,
    LastYearturnover: 205370.01,
    Regionturnover: 1428408.53,
    LastYearRegionturnover: 1448712.850000002,
  },
];

const CAByHourByHourTodayDataMock = [
  {
    CA: 0,
    horaire: 1,
  },
  {
    CA: 145.42,
    horaire: 2,
  },
  {
    CA: 570.65,
    horaire: 3,
  },
  {
    CA: 1655.6,
    horaire: 4,
  },
  {
    CA: 1836.82,
    horaire: 5,
  },
  {
    CA: 2959.84,
    horaire: 6,
  },
  {
    CA: 3231.12,
    horaire: 7,
  },
  {
    CA: 4333.57,
    horaire: 8,
  },
  {
    CA: 4587.22,
    horaire: 9,
  },
  {
    CA: 5935.57,
    horaire: 10,
  },
  {
    CA: 6463.1,
    horaire: 11,
  },
  {
    CA: 7198.15,
    horaire: 12,
  },
  {
    CA: 7607.8,
    horaire: 13,
  },
];

const CAByHourByHourLastYearDataMock = [
  {
    CA: 0,
    horaire: 1,
  },
  {
    CA: 195.42,
    horaire: 2,
  },
  {
    CA: 510.65,
    horaire: 3,
  },
  {
    CA: 1255.6,
    horaire: 4,
  },
  {
    CA: 1836.82,
    horaire: 5,
  },
  {
    CA: 2859.84,
    horaire: 6,
  },
  {
    CA: 3331.12,
    horaire: 7,
  },
  {
    CA: 4033.57,
    horaire: 8,
  },
  {
    CA: 4787.22,
    horaire: 9,
  },
  {
    CA: 5635.57,
    horaire: 10,
  },
  {
    CA: 6763.1,
    horaire: 11,
  },
  {
    CA: 7498.15,
    horaire: 12,
  },
  {
    CA: 7907.8,
    horaire: 13,
  },
];

const NPSMagasinDataMock = { promoters: 5, detractors: 1, neutrals: 1 };

const BarometerDataMock = [
  {
    storeName: "ABBEVILLE -AMIENS",
    question_code: "PC_AFFICHAGE_PRIX",
    question_label: "Affichage des prix en rayon",
    moyenne: {
      valeur: 0,
      label: "Moyenne",
    },
    total: {
      valeur: 6,
      label: "Total Répondant",
    },
  },
  {
    storeName: "ABBEVILLE -AMIENS",
    question_code: "PC_amabilite_personnel",
    question_label: "Amabilité du personnel",
    moyenne: {
      valeur: -2,
      label: "Moyenne",
    },
    total: {
      valeur: 6,
      label: "Total Répondant",
    },
  },
  {
    storeName: "ABBEVILLE -AMIENS",
    question_code: "PRODUITS_HORS_PROMO_TROUVE",
    question_label: "Disponibilité produits habituels",
    moyenne: {
      valeur: 50,
      label: "Moyenne",
    },
    total: {
      valeur: 6,
      label: "Total Répondant",
    },
  },
  {
    storeName: "ABBEVILLE -AMIENS",
    question_code: "PROMOS_TROUVE",
    question_label: "Disponibilité promotions",
    moyenne: {
      valeur: 140,
      label: "Moyenne",
    },
    total: {
      valeur: 5,
      label: "Total Répondant",
    },
  },
  {
    storeName: "ABBEVILLE -AMIENS",
    question_code: "PC_FRUITS_LEGUMES",
    question_label: "Rayon fruits et légumes",
    moyenne: {
      valeur: 200,
      label: "Moyenne",
    },
    total: {
      valeur: 6,
      label: "Total Répondant",
    },
  },
  {
    storeName: "ABBEVILLE -AMIENS",
    question_code: "PC_PASSAGE_CAISSE",
    question_label: "Temps de passage en caisses",
    moyenne: {
      valeur: 83,
      label: "Moyenne",
    },
    total: {
      valeur: 6,
      label: "Total Répondant",
    },
  },
];

const CritizrDataMock = { averageRating: 3.6, messageCount: 3 };
const DriveObjectiveDataMock = { objective: 12.242675893634999 };
const TurnoverObjectiveDataMock = { objectiveAmount: 123.048474555971 };
const DriveLastYearDataMock = { turnover: 10.9266 };
const DriveTodayDataMock = { turnover: 19.04543 };
const TurnoverLastYearDataMock = {
  turnover: 128.03246000000001,
  ticketsCount: 2554,
  averageBasket: 50.13017227877839,
};
const TurnoverTodayDataMock = {
  turnover: 66.80291,
  ticketsCount: 1461,
  averageBasket: 45.72409993155373,
};
const auditPriceDataMock = {
  priceAuditRate: 70,
};

const closingRateHyperDataMock = [
  {
    secteur: "1 - PGC",
    ecartPrice: 2,
    unknown: 4,
    illisible: 4,
    taux: 0.8,
  },
  {
    secteur: "2 - PFT",
    ecartPrice: 4,
    unknown: 5,
    illisible: 10,
    taux: 0.8421052631578947,
  },
  {
    secteur: "3 - BAZAR",
    ecartPrice: 4,
    unknown: 3,
    illisible: 6,
    taux: 0.7692307692307693,
  },
  {
    secteur: "4 - EPCS",
    ecartPrice: 1,
    unknown: 0,
    illisible: 0,
    taux: 1,
  },
  {
    secteur: "6 - TEXTILE",
    ecartPrice: 8,
    unknown: 5,
    illisible: 1,
    taux: 0.6428571428571429,
  },
];

const closingRateMarketDataMock = [
  {
    forcedClassCount: 3,
    forcedPriceCount: 0,
    unknownBarcodeCount: 0,
  },
];

const topRecurrencesDataMock = [
  {
    EAN_SAC: "8001090844965",
    Libelle_article_SAC: "FAIRY LV PLAT CITRON X39",
    Nombre_occurrences_SAC: 5,
  },
  {
    EAN_SAC: "3496182501485",
    Libelle_article_SAC: "966233 REHAUSSEUR BAS ROUGE TU",
    Nombre_occurrences_SAC: 1,
  },
  {
    EAN_SAC: "3616953349577",
    Libelle_article_SAC: "939612 TRAINING RUN FUSCHIA 35",
    Nombre_occurrences_SAC: 1,
  },
  {
    EAN_SAC: "3701123992421",
    Libelle_article_SAC: "KOO-KS120-ECOUTEURS BT",
    Nombre_occurrences_SAC: 1,
  },
  {
    EAN_SAC: "3616957971156",
    Libelle_article_SAC: "953031 JEGGING D JEAN CLAIR 6M",
    Nombre_occurrences_SAC: 1,
  },
];

const breaksNotedDataMock = {
  aval: 72.1951219512195,
  amont: 27.80487804878049,
  ruptureTotal: 205,
  listResults: [
    {
      departmentKey: "10",
      departmentDesc: "BOISSONS",
      shortCount: 0,
    },
    {
      departmentKey: "11",
      departmentDesc: "DROGUERIE",
      shortCount: 0,
    },
    {
      departmentKey: "12",
      departmentDesc: "PARFUMERIE HYGIENE",
      shortCount: 0,
    },
    {
      departmentKey: "14",
      departmentDesc: "EPICERIE",
      shortCount: 205,
    },
    {
      departmentKey: "25",
      departmentDesc: "P.L.S.",
      shortCount: 0,
    },
  ],
};

const topPgcDataMock = {
  listResults: [
    {
      hypDepartmentKey: "10",
      hypDepartmentDesc: "BOISSONS",
      rate: 91.66666666666666,
    },
    {
      hypDepartmentKey: "11",
      hypDepartmentDesc: "DROGUERIE",
      rate: 88.88888888888889,
    },
    {
      hypDepartmentKey: "12",
      hypDepartmentDesc: "PARFUMERIE HYGIENE",
      rate: 92.90780141843972,
    },
    {
      hypDepartmentKey: "14",
      hypDepartmentDesc: "EPICERIE",
      rate: 95.50930996714129,
    },
    {
      hypDepartmentKey: "25",
      hypDepartmentDesc: "P.L.S.",
      rate: 93.87402933563416,
    },
  ],
  rate: 93.97915862601313,
};

const topTop200PgcDataMock = { rang: 129, max: 146 };

const rankinPgcDataMock = { rang: 129, max: 146 };

const topPFTDataMock = {
  listResults: [
    {
      hypDepartmentKey: "20",
      hypDepartmentDesc: "Charcuterie",
      rate: 86.88524590163934,
    },
    {
      hypDepartmentKey: "21",
      hypDepartmentDesc: "Poissonnerie",
      rate: 94.08333333333334,
    },
    {
      hypDepartmentKey: "22",
      hypDepartmentDesc: "Fruits et légumes",
      rate: 85.36585365853658,
    },
    {
      hypDepartmentKey: "23",
      hypDepartmentDesc: "PVT",
      rate: 98.66666666666667,
    },
    {
      hypDepartmentKey: "24",
      hypDepartmentDesc: "Boucherie",
      rate: 80.10843373493977,
    },
  ],
  rate: 84.4311377245509,
};
const shrinkageDataMock = {
  dailyShrinkage: 5.381864800000001,
  dailyObjectiveShrinkage: 0,
  monthlyShrinkage: 52.1671745,
  monthlyObjectiveShrinkage: 0,
  ShrinkageRate: null,
  MonthToDateShrinkageRate: null,
  objectiveShrinkageRate: 72.167174,
  objectiveMonthToDateShrinkageRate: 32.167174,
};
const shrinkageRayonMock = [
  {
    departmentKey: "10",
    departmentDesc: "BOISSONS",
    shrinkageAmount: 336.3508,
  },
  {
    departmentKey: "11",
    departmentDesc: "DROGUERIE",
    shrinkageAmount: 39.98,
  },
  {
    departmentKey: "12",
    departmentDesc: "PARFUMERIE HYGIENE",
    shrinkageAmount: 56.8,
  },
  {
    departmentKey: "14",
    departmentDesc: "EPICERIE",
    shrinkageAmount: 590.35,
  },
  {
    departmentKey: "20",
    departmentDesc: "CHARCUT.TRAITEUR",
    shrinkageAmount: 834.5746,
  },
  {
    departmentKey: "21",
    departmentDesc: "POISSONNERIE",
    shrinkageAmount: 384.5173,
  },
  {
    departmentKey: "22",
    departmentDesc: "FRUITS ET LEGUMES",
    shrinkageAmount: 2956.4509,
  },
  {
    departmentKey: "23",
    departmentDesc: "BOULANGERIE/PATISSERIE",
    shrinkageAmount: 253.21,
  },
  {
    departmentKey: "24",
    departmentDesc: "BOUCHERIE VOLAILLE",
    shrinkageAmount: 977.1273,
  },
  {
    departmentKey: "25",
    departmentDesc: "P.L.S.",
    shrinkageAmount: 1807.9593,
  },
  {
    departmentKey: "31",
    departmentDesc: "CONFORT DE LA MAISON",
    shrinkageAmount: 44.6,
  },
  {
    departmentKey: "32",
    departmentDesc: "PAPETERIE",
    shrinkageAmount: 31.35,
  },
  {
    departmentKey: "33",
    departmentDesc: "JOUET SPORT",
    shrinkageAmount: 10.7,
  },
  {
    departmentKey: "34",
    departmentDesc: "JARDIN ET ANIMALERIE",
    shrinkageAmount: 9.82,
  },
  {
    departmentKey: "35",
    departmentDesc: "AUTO",
    shrinkageAmount: 62.69,
  },
];

const flop5DataMock = [
  {
    barcode: "3276557423976",
    itemDesc: "BQ 250G FRAISE MARABOIS CRF FR",
    quantity: -15.0,
    shrinkageAmount: -41.55,
  },
  {
    barcode: "3114270300214",
    itemDesc: "250G BEUR MOULE CDS LE MARIN",
    quantity: -11.0,
    shrinkageAmount: -26.62,
  },
  {
    barcode: "3523680504219",
    itemDesc: "FLT 2KG PDT VP RG CRF FR",
    quantity: -6.0,
    shrinkageAmount: -18.96,
  },
  {
    barcode: "3449865294044",
    itemDesc: "COCH ROSETTE VPF 10T 93G",
    quantity: -11.0,
    shrinkageAmount: -15.95,
  },
  {
    barcode: "3155250367094",
    itemDesc: "250G BEUR MOTTE SDM PRESIDENT",
    quantity: -5.0,
    shrinkageAmount: -13.9,
  },
];

const deavaDataMock = {
  storeGlnKey: "3021081173862",
  toInitializeItemCount: 126,
  totalInitializedItemCount: 231,
  toControlItemCount: 12,
  totalControledItemCount: 6,
};

const flopDriveDataMock = [
  {
    barCode: "3168930009917",
    desc: "Chips saveur Cheeseburger LAY'S",
    quantity: 1,
    rang: 1,
  },
  {
    barCode: "3168930009917",
    desc: "Chips saveur Cheeseburger LAY'S",
    quantity: 1,
    rang: 1,
  },
  {
    barCode: "3168930009917",
    desc: "Chips saveur Cheeseburger LAY'S",
    quantity: 1,
    rang: 1,
  },
  {
    barCode: "3168930009917",
    desc: "Chips saveur Cheeseburger LAY'S",
    quantity: 1,
    rang: 1,
  },
  {
    barCode: "3168930009917",
    desc: "Chips saveur Cheeseburger LAY'S",
    quantity: 1,
    rang: 1,
  },
  {
    barCode: "3168930009917",
    desc: "Chips saveur Cheeseburger LAY'S",
    quantity: 1,
    rang: 1,
  },
  {
    barCode: "3168930009917",
    desc: "Chips saveur Cheeseburger LAY'S",
    quantity: 1,
    rang: 1,
  },
  {
    barCode: "3168930009917",
    desc: "Chips saveur Cheeseburger LAY'S",
    quantity: 1,
    rang: 1,
  },
];

const orderStatusMockData = {
  inProgress: 0,
  toPrepare: 0,
  delivered: 77,
  ready: 13,
  canceled: { client: 0, store: 1 },
};

const complianceRateMockData = {
  beforeSubstitutionComplianceRate: 41.18,
  afterSubstitutionComplianceRate: 76.47,
};

const slotTodaymockData = [
  {
    capacity: 12,
    startTime: "2024-11-24T07:30:00.000Z",
    bookedCount: 7,
    status: "closed",
  },
  {
    capacity: 12,
    startTime: "2024-11-24T08:00:00.000Z",
    bookedCount: 7,
    status: "closed",
  },
  {
    capacity: 12,
    startTime: "2024-11-24T08:30:00.000Z",
    bookedCount: 10,
    status: "closed",
  },
  {
    capacity: 12,
    startTime: "2024-11-24T09:00:00.000Z",
    bookedCount: 5,
    status: "closed",
  },
  {
    capacity: 12,
    startTime: "2024-11-24T09:30:00.000Z",
    bookedCount: 5,
    status: "closed",
  },
  {
    capacity: 12,
    startTime: "2024-11-24T10:00:00.000Z",
    bookedCount: 9,
    status: "closed",
  },
  {
    capacity: 12,
    startTime: "2024-11-24T10:30:00.000Z",
    bookedCount: 6,
    status: "closed",
  },
];
const slotNextDayMockDate = [
  {
    capacity: 27,
    startTime: "2024-11-25T07:30:00.000Z",
    bookedCount: 14,
    status: "open",
  },
  {
    capacity: 27,
    startTime: "2024-11-25T08:00:00.000Z",
    bookedCount: 8,
    status: "open",
  },
  {
    capacity: 27,
    startTime: "2024-11-25T08:30:00.000Z",
    bookedCount: 4,
    status: "open",
  },
  {
    capacity: 27,
    startTime: "2024-11-25T09:00:00.000Z",
    bookedCount: 3,
    status: "open",
  },
  {
    capacity: 27,
    startTime: "2024-11-25T09:30:00.000Z",
    bookedCount: 5,
    status: "open",
  },
  {
    capacity: 27,
    startTime: "2024-11-25T10:00:00.000Z",
    bookedCount: 5,
    status: "open",
  },
  {
    capacity: 27,
    startTime: "2024-11-25T10:30:00.000Z",
    bookedCount: 5,
    status: "open",
  },
  {
    capacity: 27,
    startTime: "2024-11-25T11:00:00.000Z",
    bookedCount: 4,
    status: "open",
  },
  {
    capacity: 27,
    startTime: "2024-11-25T11:30:00.000Z",
    bookedCount: 6,
    status: "open",
  },
  {
    capacity: 27,
    startTime: "2024-11-25T12:00:00.000Z",
    bookedCount: 0,
    status: "open",
  },
  {
    capacity: 3,
    startTime: "2024-11-25T12:00:00.000Z",
    bookedCount: 0,
    status: "closed",
  },
  {
    capacity: 3,
    startTime: "2024-11-25T12:30:00.000Z",
    bookedCount: 0,
    status: "open",
  },
  {
    capacity: 27,
    startTime: "2024-11-25T12:30:00.000Z",
    bookedCount: 5,
    status: "open",
  },
  {
    capacity: 27,
    startTime: "2024-11-25T13:00:00.000Z",
    bookedCount: 2,
    status: "open",
  },
  {
    capacity: 3,
    startTime: "2024-11-25T13:00:00.000Z",
    bookedCount: 0,
    status: "open",
  },
  {
    capacity: 3,
    startTime: "2024-11-25T13:30:00.000Z",
    bookedCount: 0,
    status: "open",
  },
  {
    capacity: 27,
    startTime: "2024-11-25T13:30:00.000Z",
    bookedCount: 4,
    status: "open",
  },
  {
    capacity: 27,
    startTime: "2024-11-25T14:00:00.000Z",
    bookedCount: 2,
    status: "open",
  },
  {
    capacity: 3,
    startTime: "2024-11-25T14:00:00.000Z",
    bookedCount: 0,
    status: "open",
  },
  {
    capacity: 3,
    startTime: "2024-11-25T14:30:00.000Z",
    bookedCount: 0,
    status: "open",
  },
  {
    capacity: 27,
    startTime: "2024-11-25T14:30:00.000Z",
    bookedCount: 2,
    status: "open",
  },
  {
    capacity: 3,
    startTime: "2024-11-25T15:00:00.000Z",
    bookedCount: 0,
    status: "open",
  },
  {
    capacity: 27,
    startTime: "2024-11-25T15:00:00.000Z",
    bookedCount: 1,
    status: "open",
  },
  {
    capacity: 27,
    startTime: "2024-11-25T15:30:00.000Z",
    bookedCount: 3,
    status: "open",
  },
  {
    capacity: 3,
    startTime: "2024-11-25T15:30:00.000Z",
    bookedCount: 0,
    status: "open",
  },
  {
    capacity: 27,
    startTime: "2024-11-25T16:00:00.000Z",
    bookedCount: 0,
    status: "open",
  },
  {
    capacity: 3,
    startTime: "2024-11-25T16:00:00.000Z",
    bookedCount: 0,
    status: "open",
  },
  {
    capacity: 3,
    startTime: "2024-11-25T16:30:00.000Z",
    bookedCount: 0,
    status: "open",
  },
  {
    capacity: 27,
    startTime: "2024-11-25T16:30:00.000Z",
    bookedCount: 6,
    status: "open",
  },
  {
    capacity: 27,
    startTime: "2024-11-25T17:00:00.000Z",
    bookedCount: 5,
    status: "open",
  },
  {
    capacity: 3,
    startTime: "2024-11-25T17:00:00.000Z",
    bookedCount: 0,
    status: "open",
  },
  {
    capacity: 3,
    startTime: "2024-11-25T17:30:00.000Z",
    bookedCount: 0,
    status: "open",
  },
  {
    capacity: 27,
    startTime: "2024-11-25T17:30:00.000Z",
    bookedCount: 27,
    status: "closed",
  },
  {
    capacity: 27,
    startTime: "2024-11-25T18:00:00.000Z",
    bookedCount: 4,
    status: "open",
  },
  {
    capacity: 3,
    startTime: "2024-11-25T18:00:00.000Z",
    bookedCount: 0,
    status: "open",
  },
  {
    capacity: 27,
    startTime: "2024-11-25T18:30:00.000Z",
    bookedCount: 2,
    status: "open",
  },
];
const vabDataMock = {
  toControl: 70,
  controlled: 34,
};
export {
  storesDataMock,
  sectorHyperDataMock,
  sectorMarketDataMock,
  ComparativeMarketDataMock,
  ComparativeHyperDataMock,
  CAByHourByHourLastYearDataMock,
  CAByHourByHourTodayDataMock,
  NPSMagasinDataMock,
  BarometerDataMock,
  CritizrDataMock,
  TurnoverObjectiveDataMock,
  DriveObjectiveDataMock,
  DriveLastYearDataMock,
  DriveTodayDataMock,
  TurnoverLastYearDataMock,
  TurnoverTodayDataMock,
  auditPriceDataMock,
  closingRateHyperDataMock,
  closingRateMarketDataMock,
  topRecurrencesDataMock,
  breaksNotedDataMock,
  topPgcDataMock,
  rankinPgcDataMock,
  topTop200PgcDataMock,
  topPFTDataMock,
  shrinkageDataMock,
  shrinkageRayonMock,
  flop5DataMock,
  deavaDataMock,
  flopDriveDataMock,
  orderStatusMockData,
  complianceRateMockData,
  slotTodaymockData,
  slotNextDayMockDate,
  vabDataMock,
};
